import React from "react";
import StripeConnect from "../components/StripeConnect";

const StripeConnectApp = (props) => <StripeConnect {...props} />;

export default StripeConnectApp;
